import { createAction, props } from '@ngrx/store';

export const AddPaymentMethodFailureCount = createAction(
  '[BillingSharedFeature] Add Payment Method Failure Count',
  props<{ addPaymentMethodFailureCount: number }>()
);
